module.exports = __webpack_public_path__ + "8373365b715b8b5e770c3e1cf43c5374.png";